import React from "react";
import { useForm } from "@/src/provider/Form/FormProvider";
import DateFieldConfigured from "@/src/components/Form/ConfiguredFormElements/DateFieldConfigured/DateFieldConfigured";
import { FormHeaderWrapper } from "@/src/components/Form/Common/FormHeaderWrapper/FormHeaderWrapper";
import SingleSelectFieldConfigured from "@/src/components/Form/ConfiguredFormElements/SingleSelectFieldConfigured/SingleSelectFieldConfigured";
import TextFieldConfigured from "@/src/components/Form/ConfiguredFormElements/TextFieldConfigured/TextFieldConfigured";
import RadioGroupConfigured from "@/src/components/Form/ConfiguredFormElements/RadioGroupConfigured/RadioGroupConfigured";
import { ContractDetailsProps } from "@/src/types/ContractDetailsProps";

export default function ProviderContractDetails({ product, submitProps }: ContractDetailsProps) {
  const { values, handleSubmit }: any = useForm();
  return (
    <FormHeaderWrapper submitProps={submitProps} handleSubmit={handleSubmit}>
      <SingleSelectFieldConfigured caseData={values} fieldPath={"providerType"} required />
      <RadioGroupConfigured caseData={values} fieldPath={"reasonForDispute"} required />

      {values.reasonForDispute === "cancellationByProvider" && (
        <DateFieldConfigured caseData={product} fieldPath={"cancellationReceivedDate"} dateValidation={"pastOrToday"} required />
      )}

      {values.reasonForDispute === "priceIncrease" && (
        <DateFieldConfigured caseData={product} fieldPath={"priceIncreaseAnnouncementDate"} dateValidation={"pastOrToday"} required />
      )}

      {values.reasonForDispute === "cancellationRefused" && (
        <>
          <DateFieldConfigured caseData={product} fieldPath={"cancellationDate"} dateValidation={"pastOrToday"} required />
          <DateFieldConfigured caseData={product} fieldPath={"endOfContractDate"} />
          <RadioGroupConfigured caseData={values} fieldPath={"opponentReactionToCancellation"} required />
          {values.opponentReactionToCancellation === "differentDate" && <DateFieldConfigured caseData={product} fieldPath={"endOfContractDateOpponent"} />}
        </>
      )}
      <TextFieldConfigured caseData={product} fieldPath={"contractNumber"} required />
    </FormHeaderWrapper>
  );
}
